import { render, staticRenderFns } from "./tableDtl.vue?vue&type=template&id=330ba4d8&scoped=true&"
import script from "./tableDtl.vue?vue&type=script&lang=js&"
export * from "./tableDtl.vue?vue&type=script&lang=js&"
import style1 from "./tableDtl.vue?vue&type=style&index=1&id=330ba4d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ba4d8",
  null
  
)

export default component.exports